import { useEffect, useMemo, useState } from "react";
import WelcomePng from "../Assets/Images/Welcome.png";
import WeddinglyLogo from "../Assets/Images/logo-auth.svg";
import Cursor from "../Assets/Images/cursor-left.svg";
import { Link } from "react-router-dom";
import GoogleAuthButton from "../Components/GoogleAuthButton";
import Divider from "../Components/Divider";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TncText from "../Components/TncText";
import useTnC from "../Hooks/useTnC";

const Landing = () => {
  const navigate = useNavigate();
  const { tncHTML } = useTnC();

  const [tncOpen, setTncOpen] = useState(false);

  useEffect(() => {
    // Remove chatId from session storage when user enter login page
    sessionStorage.removeItem("chatId");
    sessionStorage.removeItem("promptText");
  }, []);

  const renderAuthFormContent = useMemo(() => {
    if (tncOpen) {
      return (
        <>
          <p className="form-head-text form-head-text-small">
            Terms, Payment and Data Privacy
          </p>
          <div
            className="terms-text-wrapper  mobile-terms-wrapper"
            dangerouslySetInnerHTML={{ __html: tncHTML }}
          />
        </>
      );
    }

    return (
      <>
        <p className="form-head-text tex-sm">Welcome back</p>
        <GoogleAuthButton />
        <Divider />
        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: "#FB4764",
            "&:hover": {
              backgroundColor: "#FB4764",
            },
            height: "60px",
            fontSize: "25px",
            fontWeight: "400",
            display: "flex",
            color: "#ffff",
            boxShadow: "none",
            borderRadius: "15px",
            textTransform: "none", // Prevent text from being all caps,
            fontFamily: "Inter",
          }}
          onClick={() => navigate("/Login")}
        >
          Continue with Email
        </Button>

        <div style={{ marginTop: "20px" }}>
          <TncText onClick={() => setTncOpen(true)} />
        </div>
      </>
    );
  }, [navigate, tncHTML, tncOpen]);

  return (
    <main className="auth-wrapper">
      <Link hidden id="link-to-home" to="/Home"></Link>
      <section className="auth-left-wrapper">
        <div className="auth-vector-container">
          <img className="auth-vector" alt="welcome" src={WelcomePng} />
        </div>
        <img
          src={WeddinglyLogo}
          alt="weddingly logo"
          className="auth-weddingly-logo"
        />
      </section>
      <section className="auth-right-wrapper">
        <div className="section-head-action is-desktop">
          {tncOpen ? (
            <div className="back-to-landing" onClick={() => setTncOpen(false)}>
              <img alt="" src={Cursor} />
              <p>Back to landing</p>
            </div>
          ) : (
            <a href="https://www.weddingly.io/">
              <img alt="" src={Cursor} />
              <p>Back to homepage</p>
            </a>
          )}
        </div>
        <div
          className={`auth-form ${tncOpen ? "big-form" : ""}`}
          style={tncOpen ? { minWidth: "80%" } : {}}
        >
          {renderAuthFormContent}
        </div>

        {tncOpen && (
          <span className="back-btn" onClick={() => setTncOpen(false)}>
            Back to landing
          </span>
        )}
      </section>
    </main>
  );
};

export default Landing;
